import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Composer } from '@/features/composer/Composer'
import { ConnectChannelsModal } from '@/features/channels/ConnectChannelsModal'
import { useUI } from '@/lib/ui'

export function Layout() {
  const { composerOpen, connectOpen, closeComposer, closeConnect, composerPrefill } = useUI()
  return (
    <div className="flex h-dvh overflow-hidden bg-page pt-12 md:pt-0">
      <Sidebar />
      <main id="main-content" className="flex min-w-0 flex-1 flex-col overflow-hidden pb-[74px] md:pb-0">
        <Outlet />
      </main>
      <Composer open={composerOpen} onClose={closeComposer} prefill={composerPrefill} />
      <ConnectChannelsModal open={connectOpen} onClose={closeConnect} />
    </div>
  )
}
